import "react-toastify/dist/ReactToastify.css"

import App from "./App";
import { HashRouter } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom";
import {ToastContainer} from "react-toastify";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <HashRouter>
    <ToastContainer />
    <App />
  </HashRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
